export const painPoints = [
  'Te levantás cansada aunque hayas dormido las horas necesarias.',
  'Sentís hinchazón sin saber qué la genera.',
  'El hambre aparece fuera de horario y los antojos te ganan a la tarde.',
  'Probaste de todo y nada funcionó de forma sostenida.',
  'Sentís que tu cuerpo cambió después de los 55 y no sabés cómo acompañarlo.',
]

export const volumes = [
  [
    'Volumen 1 — Mapa de los Bloqueadores Metabólicos',
    [
      'Entendés qué factores de tu rutina pueden influir en cómo te sentís después de los 55',
      'Identificás qué hábitos cotidianos pueden estar sumando carga a tu sistema',
      'Descubrís tu “bloqueador dominante” con un test simple y sin tecnicismos',
      'Conectás alimentación, descanso, estrés y movimiento en un solo mapa claro',
      'Arrancás sabiendo exactamente por dónde empezar',
    ],
    'border-blue-400/30',
  ],
  [
    'Volumen 2 — Ingeniería de la Energía Cotidiana',
    [
      'Aprendés a organizar tus comidas para evitar llegar con hambre extrema a la tarde',
      'Organizás tus compras y tu cocina para no improvisar más',
      'Hacés reemplazos simples con ingredientes del súper de siempre',
      'Armás una rutina diaria que no depende de la fuerza de voluntad',
      'Reducís la toma de decisiones diaria sobre qué comer',
    ],
    'border-green-400/30',
  ],
  [
    'Volumen 3 — Señales del Cuerpo',
    [
      'Aprendés a diferenciar el hambre física del hambre emocional o el aburrimiento',
      'Entendés por qué a las 19hs aparecen los antojos y cómo gestionarlos',
      'Dejás de comer por impulso y empezás a comer con más conciencia',
      'Reconocés las señales de tu propio cuerpo en lugar de seguir reglas externas',
      'Recuperás una relación más tranquila con la comida',
    ],
    'border-amber-400/30',
  ],
  [
    'Volumen 4 — Ritmo Metabólico en la Vida Real',
    [
      'Sabés cómo manejarte en asados, cumpleaños y salidas sin sentirte culpable',
      'Disfrutás de una pizza o una copa de vino sin que eso arruine la semana',
      'Tenés un plan para los días caóticos donde todo se desordena',
      'Dejás de vivir en la lógica de “ya arruiné todo, mañana empiezo”',
      'Sostenés el equilibrio en tu vida social real sin aislarte ni privarte',
    ],
    'border-red-400/30',
  ],
  [
    'Volumen 5 — Sistema de Equilibrio Sostenible',
    [
      'Revisás qué cambió en tu energía, digestión y ánimo durante los 10 días',
      'Definís los hábitos mínimos que van a sostenerte aunque la vida se complique',
      'Aprendés a detectar cuándo los viejos patrones están volviendo',
      'Pasás de “estar siguiendo un protocolo” a tener una rutina propia',
      'Te quedás con un sistema aplicable más allá de los 10 días',
    ],
    'border-yellow-400/30',
  ],
] as const

export const included = [
  'Plan diario listo para arrancar hoy',
  'Cronograma de implementación de 10 días',
  'Guía de registro de señales y ajustes',
  'Checklists imprimibles por etapa',
]

export const bonuses = [
  [
    '01',
    'Radar Express de Bloqueadores™',
    [
      'Identificás en 10 minutos qué área de tu rutina necesita más atención',
      'Respondés un test simple sin conocimientos previos',
      'Empezás el protocolo con dirección clara, no a ciegas',
      'Priorizás un solo cambio para no abrumarte desde el día 1',
      'Llegás al Día 1 sabiendo exactamente por dónde arrancar',
    ],
    '$12.000',
  ],
  [
    '02',
    'Planificador 10 Días Sin Improvisar™',
    [
      'Tenés cada día organizado con un foco y una acción concreta',
      'Usás checklists de mañana, tarde y noche sin depender de la memoria',
      'Evitás el abandono por falta de estructura',
      'Sabés qué hacer cada día sin tener que pensar de más',
      'Disponible para imprimir o usar desde el celular',
    ],
    '$10.000',
  ],
  [
    '03',
    'Constructor de Platos Sostenidos™',
    [
      'Armás comidas más completas con lo que ya tenés en la heladera',
      'Usás la fórmula 3+1 para no quedar con hambre dos horas después',
      'Evitás los errores que disparan los antojos de la tarde',
      'Resolvés en 5 minutos qué comer sin improvisar',
      'Una hoja imprimible lista para pegar en la heladera',
    ],
    '$9.000',
  ],
  [
    '04',
    'Kit Anticaos para Días Reales™',
    [
      'Sabés qué hacer antes, durante y después de cualquier salida social',
      'Manejás asados, pizzerías y cumpleaños sin culpa ni excesos',
      'Volvés al eje al día siguiente sin castigarte ni empezar de cero',
      'La vida social deja de ser un obstáculo para tu bienestar',
      'Tenés respuestas listas para cuando el entorno te complica',
    ],
    '$11.000',
  ],
  [
    '05',
    'Tracker de Señales y Ajustes™',
    [
      'Registrás en 2 minutos cómo te sentís cada día',
      'Detectás tus patrones personales de energía, hambre y descanso',
      'Descubrís qué hábitos te sostienen y cuáles te desordenan',
      'Medís tu proceso sin depender únicamente de la balanza',
      'Terminás los 10 días con aprendizajes concretos sobre tu propio cuerpo',
    ],
    '$10.000',
  ],
] as const

export const testimonials = [
  ['GR', 'Graciela R.', 'Buenos Aires', 'En una semana dejé de llegar a la cena con hambre desesperada. No puedo creer que algo tan simple marcara tanta diferencia.'],
  ['ML', 'Marta L.', 'Córdoba', 'Empecé a entender por qué me sentía tan hinchada. Nadie me lo había explicado así de claro.'],
  ['NP', 'Nora P.', 'Rosario', 'Al día 7 ya notaba un cambio real. El orden en las comidas fue lo que más me ayudó.'],
] as const

export const extendedTestimonials = [
  ['Graciela R.', 'Buenos Aires', '“Llevaba años sintiéndome hinchada sin entender por qué. Al día 8 ya me sentía diferente. Por fin entendí qué me estaba pasando.”'],
  ['Marta L.', 'Córdoba', '“El test de bloqueadores me hizo ver que el problema era mi horario de cenas. Algo tan simple que nunca había conectado.”'],
  ['Nora P.', 'Rosario', '“Me despertaba agotada todos los días. Ordenar la rutina me cambió el descanso. No lo podía creer.”'],
  ['Elena M.', 'Mendoza', '“Empecé con dudas porque ya había probado de todo. Pero esto es diferente porque te explica el por qué. Eso fue lo que me faltaba.”'],
] as const

export const faqs = [
  ['¿Necesito saber de nutrición para aplicarlo?', 'No. Está explicado en lenguaje simple, paso a paso, sin tecnicismos.'],
  ['¿Los cambios son difíciles de hacer en mi rutina diaria?', 'No. Está diseñado para la vida real: familia, salidas y compras en el súper de siempre.'],
  ['¿Cuándo puedo empezar a notar algo diferente?', 'Depende de cada persona. Algunas notan cambios en pocos días y otras necesitan más tiempo.'],
  ['¿La garantía es real?', 'Sí. Tenés 10 días. Si no quedás conforme, escribís a soporte y te devolvemos el 100%.'],
  ['¿Es 100% digital?', 'Sí. Recibís acceso a todos los PDF en menos de 5 minutos desde cualquier dispositivo.'],
] as const

export const costs = [
  'Seguís probando dietas que duran dos semanas y después no',
  'Seguís llegando a la tarde con antojos que te ganan',
  'Seguís sin entender qué está pasando en tu propio cuerpo',
  'Otro año sin un sistema claro, sin dirección y sin resultados sostenibles',
]

export const purchases = [
  ['Graciela R.', 'Buenos Aires'],
  ['Marta L.', 'Córdoba'],
  ['Nora P.', 'Rosario'],
  ['Elena M.', 'Mendoza'],
] as const
